import React from "react";
import "./Button.scss";

const Button = ({
                    type = "primary",
                    size = "medium",
                    icon,
                    children,
                    className = "",
                    ...rest
                }) => {
    const typeClass = {
        primary: "btn-primary",
        secondary: "btn-secondary",
        border: "btn-border",
        borderless: "btn-borderless"
    }[type] || "btn-primary";


    const sizeClass = {
        small: "btn-small",
        medium: "btn-medium",
        large: "btn-large"
    }[size] || "btn-medium";

    return (
        <button
            className={`custom-btn ${typeClass} ${sizeClass} ${className}`}
            {...rest}
        >
            {icon && <span className="btn-icon">{icon}</span>}
            {children}
        </button>
    );
};

export default Button;
